const toNumber = (value, fallback = 0) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};

const parseDateMs = (value) => {
  if (!value) return null;
  const ms = Date.parse(value);
  return Number.isFinite(ms) ? ms : null;
};

export const isWithinSchedule = (startsAt, endsAt, nowMs = Date.now()) => {
  const startMs = parseDateMs(startsAt);
  const endMs = parseDateMs(endsAt);
  if (startMs && nowMs < startMs) return false;
  if (endMs && nowMs > endMs) return false;
  return true;
};

export const getActiveCampaigns = (campaigns = [], nowMs = Date.now()) => {
  if (!Array.isArray(campaigns)) return [];
  return campaigns.filter((c) => {
    if (!c) return false;
    if (c.active === false) return false;
    return isWithinSchedule(c.startsAt, c.endsAt, nowMs);
  });
};

export const getBestCampaignForProduct = (campaigns = [], productId, nowMs = Date.now()) => {
  if (!productId) return null;
  const active = getActiveCampaigns(campaigns, nowMs);
  const matches = active.filter((c) => Array.isArray(c.productIds) && c.productIds.includes(productId));
  if (!matches.length) return null;
  matches.sort((a, b) => toNumber(b.discountPercent) - toNumber(a.discountPercent));
  return matches[0];
};

export const getEffectiveProductPricing = (product, campaigns = [], nowMs = Date.now()) => {
  const basePrice = toNumber(product?.price);
  const compareAt = toNumber(product?.compareAtPrice, 0);
  const hasCompareAt = compareAt > 0 && compareAt > basePrice;

  const campaign = getBestCampaignForProduct(campaigns, product?.id, nowMs);
  const discountPercent = Math.max(0, toNumber(campaign?.discountPercent, 0));
  const hasCampaignDiscount = discountPercent > 0;

  const discountedPrice = hasCampaignDiscount ? basePrice * (1 - discountPercent / 100) : basePrice;
  const finalPrice = Math.round(discountedPrice * 100) / 100;

  const originalPrice = hasCompareAt ? compareAt : basePrice;
  const showCompareAt = hasCampaignDiscount ? originalPrice : hasCompareAt ? compareAt : null;

  const badgeText =
    campaign?.badgeText ||
    (hasCampaignDiscount ? `${Math.round(discountPercent)}% OFF` : hasCompareAt ? 'SALE' : '');

  const savings = showCompareAt ? Math.max(0, toNumber(showCompareAt) - finalPrice) : 0;

  return {
    basePrice,
    finalPrice,
    compareAtPrice: showCompareAt,
    savings,
    badgeText,
    campaign: campaign
      ? {
          id: campaign.id,
          title: campaign.title,
          discountPercent,
        }
      : null,
  };
};

export const formatMoney = (amount, currency) => {
  const safe = toNumber(amount, 0);
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(safe);
  } catch (e) {
    return `${safe} ${currency || ''}`.trim();
  }
};

